import { useEffect } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

const UPDATE_CHECK_INTERVAL_MS = 30 * 60 * 1000;

/**
 * Detecta nova versão do sistema via service worker (registerType 'prompt' no vite.config.mts)
 * e pede confirmação pra reiniciar. Necessário sobretudo no app desktop (Electron): a janela
 * fica aberta por horas sem nunca navegar/recarregar sozinha, então o SW nunca checaria por
 * conta própria se não forçarmos `registration.update()` periodicamente.
 */
export default function AppUpdatePrompt() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_url, registration) {
      if (!registration) return;
      const interval = setInterval(() => {
        registration.update().catch(() => {});
      }, UPDATE_CHECK_INTERVAL_MS);
      return () => clearInterval(interval);
    },
  });

  // useRegisterSW não limpa o setInterval sozinho (o retorno de onRegisteredSW é ignorado
  // pela lib) — como o componente fica montado pra sempre enquanto logado, não é crítico,
  // mas evita duplicar o interval se o componente remontar em dev/HMR.
  useEffect(() => () => setNeedRefresh(false), [setNeedRefresh]);

  return (
    <Dialog open={needRefresh} aria-labelledby="update-dialog-title">
      <DialogTitle id="update-dialog-title">Nova versão disponível</DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          Uma nova versão do sistema já está disponível. Reinicie para atualizar.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={() => setNeedRefresh(false)} color="inherit">
          Depois
        </Button>
        <Button onClick={() => updateServiceWorker(true)} variant="contained" autoFocus>
          Reiniciar agora
        </Button>
      </DialogActions>
    </Dialog>
  );
}
